// Libs
import { useState } from "react";

/**
 * Hook to handle committed value
 * @param {string|number|undefined} value initiale value
 * @param {func} onChange onChange function for the input
 * @returns {onChange, currentValue}
 */
export function useOnChangeCommitted({
    value,
    onChange,
}: {
    value?: number | string | undefined;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
}): {
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    currentValue: number | string | undefined;
} {
    const [currentValue, setCurrentValue] = useState(value);

    function newOnChange(e) {
        if (onChange) {
            onChange(e);
        }
        if (e?.target?.value) {
            setCurrentValue(e.target.value);
            return;
        }
        setCurrentValue(e);
    }

    return { onChange: newOnChange, currentValue };
}
